module.exports = __webpack_public_path__ + "static/img/aistudio.104a802.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programs_icons/aistudio.svg
// module id = OYYI
// module chunks = 1